import * as React from "react";

// import Select from "@mui/material/Select";
import {
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Box,
  Chip,
  Checkbox,
  Select,
  FormControl,
} from "@material-ui/core";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultiDropdown(props) {
  const { options, valueKey, label, chips, onChange, minWidth } = props;
  const [value, setValue] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    // On autofill we get a stringified value.
    const newVal = typeof value === "string" ? value.split(",") : value;

    setValue(newVal);

    onChange(newVal);
  };

  const treatedVals = React.useMemo(() => {
    if (!options || !Array.isArray(options)) return [];
    if (valueKey) return options.map((el) => el[valueKey]);
    return options;
  }, [options, valueKey]);

  const renderValue = React.useCallback(
    (selected) => {
      if (chips) {
        return (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={value} />
            ))}
          </Box>
        );
      }

      return selected.join(", ");
    },
    [chips]
  );

  return (
    <FormControl
      style={{ minWidth: minWidth || 200 }}
      sx={{ m: 1, width: 300 }}
    >
      {label && (
        <InputLabel id="demo-multiple-checkbox-label">{label}</InputLabel>
      )}
      <Select
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label="Tag" />}
        renderValue={renderValue}
        MenuProps={MenuProps}
        inputProps={{ "aria-label": "Without label" }}
      >
        {treatedVals.map((val) => (
          <MenuItem key={val} value={val}>
            <Checkbox checked={value.indexOf(val) > -1} />
            <ListItemText
              style={{ textTransform: "capitalize" }}
              primary={val}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
